import styled from 'styled-components';

export const Container = styled.li`
  display: flex;
  align-items: baseline;
  margin-bottom: 12px;

  &:last-child {
    margin-bottom: 0;
  }
`;

export const Icon = styled.img`
  width: 14px;
  margin-right: 10px;
`;

export const Text = styled.h5`
  color: #fff;
`;
